<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Stock',
  data() {
    return {}
  }
}
</script>
<style lang="" scoped></style>
